import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {OmsOrderStatusType} from "../../types/oms-order-status.type";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {OmsDialogService} from "../../services/oms-dialog-service.service";
import {OmsOrdersAlertsService} from "../../services/oms-orders-alerts.service";
import {OmsRequestsService} from "../../services/oms-requests.service";
import {OmsService} from "../../services/oms-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {FulfillmentStepStatusType} from "../../../fulfillment/types/fulfillment-step-status.type";

export class OmsOrderActionMenuController implements IController {

  order: any;
  fulfillment: any;
  deliverySchedulingStateReference: any;
  onAssign: Function;
  onEditCompletedOrder: Function;
  onSendToDispatch: Function;
  onRecoverComplete: Function;
  onViewSchedulingLink: Function;
  canSendToDispatch: boolean;

  public canRecover: boolean;
  public allowPrintingBillOfLading: boolean;
  public orderStatuses: typeof OmsOrderStatusType = OmsOrderStatusType;
  public fulfillmentSteps: any;

  /* @ngInject */
  constructor(private bringozLoaderService: BringozLoaderService, private confirmDialogService: ConfirmDialogService, private omsDialogService: OmsDialogService, private omsService: OmsService, private IAMPermissions,
              private $log, private $state, private omsRequestsService: OmsRequestsService, private omsOrdersAlertsService: OmsOrdersAlertsService, private splitService: SplitService, private fileDownloader, private filePrinter) {
    this.canRecover = this.IAMPermissions.hasRole('site.owner') || this.IAMPermissions.hasRole('super.owner');
  }

  $onInit() {
    this.allowPrintingBillOfLading = this.splitService.isPrintingBillOfLadingAllowed();
    if (!!this.fulfillment) {
      this._initFulfillmentSteps();
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.fulfillment && !changes.fulfillment.isFirstChange()) {
      if (!!this.fulfillment) {
        this._initFulfillmentSteps();
      }
    }
  }

  onOpen($mdMenu, event) {
    $mdMenu.open(event);
  }

  private _initFulfillmentSteps() {
    this.fulfillmentSteps = _.filter(this.fulfillment?.fulfillmentSteps, (s) => {
      return (s.status !== FulfillmentStepStatusType.Completed) &&
        (s.status !== FulfillmentStepStatusType.Failed) &&
        (s.status !== FulfillmentStepStatusType.OnHold) &&
        (s.status !== FulfillmentStepStatusType.Canceled);
    })
  }

  onEdit() {
    this.order.status !== 'Completed' ? this.$state.go('order.edit', {id: this.order.id}, {
      notify: true,
      reload: false
    }) : this._editCompletedOrder();
  }

  onDuplicate() {
    this.$state.go('order.duplicate', {id: this.order.id}, {notify: true, reload: false});
  }

  onCancelOrder(event) {
    this.omsService.onCancelOrder(this.order.id, event);
  }

  onScheduleDelivery(event) {
    this.omsDialogService.scheduleDeliveries(event)
      .then((schedule) => {
        this.bringozLoaderService.on();
        this.omsRequestsService.scheduleDeliveries(this.order.id, schedule.programType, schedule.notBefore, schedule.notAfter)
          .then(() => {
            this.omsOrdersAlertsService.scheduleOrderSuccess();
          })
          .catch(() => {
            this.omsOrdersAlertsService.scheduleOrderError();
          })
          .finally(() => {
            this.bringozLoaderService.off();
          });
      })
      .catch(() => {
        this.$log.debug('Closed Dialog');
      });
  }

  onPrintBillOfLading() {
    this.omsService.onGetBOLOrderIdToPdf(this.order.id)
      .then((res: any) => {
        if (res.data) {
          let fileName = res.headers('content-disposition').split('filename = ')[1];
          this.filePrinter(res.data, fileName, _.get(res.headers(), "content-type"))
        }
      })
  }

  onDownloadBillOfLading() {
    this.omsService.onGetBOLOrderIdToPdf(this.order.id)
      .then((res: any) => {
        if (res.data) {
          let fileName = res.headers('content-disposition').split('filename = ')[1];
          this.fileDownloader(res.data, fileName, _.get(res.headers(), "content-type"))
        }
      })
  }

  onAddNote($event) {
    this.omsService.onAddNote($event, this.order.id);
  }

  onSetOrderOnHold() {
    this.omsService.onSetOrderOnHold(this.order.id);
  }

  onResumeOrder() {
    this.omsDialogService.onResumeOrder().then(res => {
      this.resumeOrder(res);
    })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  private resumeOrder(isSendSchedulingFormToClient) {
    this.omsService.resumeOrder(this.order.id, isSendSchedulingFormToClient);
  }


  onManuallyCompleteOrder() {
    this.omsService.manuallyCompleteOrder(this.order.id);
  }

  onSendSchedulingSMSClicked($event) {
    if (this.order.status !== 'NotScheduled') {
      this.omsDialogService.confirmReschedulingForm($event)
        .then((result) => {
          if (result) {
            this.omsService.sendSchedulingLink(this.order.id, result);
          }
        })
        .catch(() => {
        })
    } else {
      this.omsService.sendSchedulingLink(this.order.id);
    }
  }

  onSendSchedulingWhatsappClicked($event) {
    if (this.order.status !== 'NotScheduled') {
      this.omsDialogService.confirmReschedulingForm($event)
        .then((result) => {
          if (result) {
            this.omsService.sendSchedulingLinkWhatsapp(this.order.id, result);
          }
        })
        .catch(() => {
        })
    } else {
      this.omsService.sendSchedulingLinkWhatsapp(this.order.id);
    }
  }

  onRecover() {
    this.omsService.recoverOrder(this.order.id)
      .then((fulfillment: any) => {
        this.onRecoverComplete({fulfillmentId: fulfillment.id});
      })
      .catch((error) => {
        this.$log.error('Failed to recover order', error);
      })
  }

  private _editCompletedOrder() {
    const orderEditStatus = this.omsService.checkOrderEditStatus(this.order.omsEditableStatus);
    if (orderEditStatus.isEditable) {
      const orderCopy = angular.copy(this.order);
      this.omsDialogService.editCompletedOrder(orderCopy)
        .then((updatedOrder) => {
          this._updateCompletedOrder(updatedOrder);
        })
    } else {
      this.omsDialogService.blockedOrderEditReasonsList(orderEditStatus.reasons);
    }
  }

  private _updateCompletedOrder(order) {
    this.omsService.updateCompletedOrder(order.id, order)
      .then((updatedOrder) => {
        this.onEditCompletedOrder({updatedOrder: updatedOrder})
      })
  }

}

angular
  .module('bringoz.admin.oms')
  .component('omsOrderActionMenu', {
    bindings: {
      order: '<',
      fulfillment: '<?',
      deliverySchedulingStateReference: '<?',
      onAssign: '&',
      onEditCompletedOrder: '&',
      onSendToDispatch: '&',
      onRecoverComplete: '&',
      onViewSchedulingLink: '&',
      canSendToDispatch: '<?',
    },
    template: require('./oms-order-action-menu.html').default,
    controller: OmsOrderActionMenuController
  });
